import { render, staticRenderFns } from "./zjlist.vue?vue&type=template&id=0aeafac3&scoped=true&"
import script from "./zjlist.vue?vue&type=script&lang=js&"
export * from "./zjlist.vue?vue&type=script&lang=js&"
import style0 from "./zjlist.vue?vue&type=style&index=0&id=0aeafac3&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeafac3",
  null
  
)

export default component.exports